<div class="row col-12 col-sm-12 edit-user-registration-container my-account-container">
  <div class="col-3 col-sm-3 left-side my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'UsersNavNode'"
      [childNavState]="'RegistrationRequestNavNode'"></app-my-account-left-sidenav>
  </div>

  <div class="editUserContainer col-12 col-sm-12 col-md-12 col-lg-9 right-side my-account-right-nav">
    <div class="userDetailTopHeader">{{'common.text_user_registraion_request_label'|cxTranslate}}</div>
    <div class="account-status">
      <span class="bold-text">{{'common.text_account_order_status_title'|cxTranslate}}</span>
      <span>&nbsp;:&nbsp;{{'common.text_account_order_status_display_error'|cxTranslate}}</span>
    </div>
    <div class="form-field-control edit-user-form-control">
      <div class="mt-3">
        <form [formGroup]="editUserForm" *ngIf="editUserInfo" (click)="$event.stopPropagation()"
          (keyup.enter)="$event.stopPropagation()" (ngSubmit)="onSubmit()">
          <!-- email address -->
          <div class="d-flex flex-lg-row flex-column">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="email" class="control-label">{{'common.register_email_mandatory'|cxTranslate}}</label>
              <input type="text" readonly="true" class="form-control email-readonly" formControlName="email" />
            </div>
            <!--Title-->
            <ng-container *ngIf=pageFieldData>
              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <label for="confirmPassword" class="control-label">{{'common.register_title'|cxTranslate}}</label>
                <div class="select-box">
                  <select name="industry" class="form-control" formControlName="title">
                    <option *ngFor="let item of pageFieldData.titlesWSList" [value]="item.code">{{item.name}}</option>
                  </select>
                </div>
              </div>
            </ng-container>

          </div>
          <!--First Name-->
          <div class="d-flex flex-lg-row flex-column">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="firstName" class="control-label">{{'common.register_firstName'|cxTranslate}}</label>
              <input type="text" formControlName="firstName" class="form-control"
                [ngClass]="{ 'is-valid': (f.firstName.dirty || submitted) && !f.firstName.errors, 'is-invalid': (f.firstName.dirty || submitted) && f.firstName.errors }"
                name="firstName">
              <div class="invalid-feedback">
                <span class="text-danger-show"
                  *ngIf=" f['firstName']?.errors && f['firstName']?.errors['required']">{{'common.register_firstName_invalid'|cxTranslate}}</span>
              </div>
            </div>
            <!--Last Name-->
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="lastName" class="control-label">{{'common.register_lastName'|cxTranslate}}</label>
              <input type="text" formControlName="lastName" class="form-control" name="lastName"
                [ngClass]="{ 'is-valid': (f.lastName.dirty || submitted) && !f.lastName.errors, 'is-invalid': (f.lastName.dirty || submitted) && f.lastName.errors }">
              <div class="invalid-feedback">
                <span class="text-danger-show"
                  *ngIf=" f['lastName']?.errors && f['lastName']?.errors['required']">{{'common.register_lastName_invalid'|cxTranslate}}</span>
              </div>
            </div>

          </div>

          <!--Company Name-->
          <div class="d-flex flex-lg-row flex-column">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="companyName" class="control-label">{{'common.register_company_name'|cxTranslate}}</label>
              <input type="text" formControlName="companyName" class="form-control" name="companyName"
                [ngClass]="{ 'is-valid': (f.companyName.dirty || submitted) && !f.companyName.errors, 'is-invalid': (f.companyName.dirty || submitted) && f.companyName.errors }">
              <div class="invalid-feedback">
                <span class="text-danger-show"
                  *ngIf=" f['companyName']?.errors && f['companyName']?.errors['required']">{{'common.register_company_name_invalid'|cxTranslate}}</span>
              </div>
            </div>
            <!--Sold To-->
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="address1"
                class="control-label">{{'common.register_company_address_street'|cxTranslate}}</label>
              <input type="text" formControlName="address1" class="form-control" name="address1"
                [ngClass]="{ 'is-valid': (f.address1.dirty || submitted) && !f.address1.errors, 'is-invalid': (f.address1.dirty || submitted) && f.address1.errors }">
              <div class="invalid-feedback">
                <span class="text-danger-show"
                  *ngIf=" f['address1']?.errors && f['address1']?.errors['required']">{{'common.register_company_address_street_invalid'|cxTranslate}}</span>
              </div>
            </div>
          </div>

          <!--Address1-->
          <div class="d-flex flex-lg-row flex-column">

            <!--Address2-->
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="houseNumber"
                class="control-label">{{'common.register_company_address_two'|cxTranslate}}</label>
              <input type="text" formControlName="houseNumber" class="form-control" name="houseNumber">
            </div>
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="city" class="control-label">{{'common.register_company_address_city'|cxTranslate}}</label>
              <input type="text" formControlName="city" class="form-control" name="city"
                [ngClass]="{ 'is-valid': (f.city.dirty || submitted) && !f.city.errors, 'is-invalid': (f.city.dirty || submitted) && f.city.errors }">
              <div class="invalid-feedback">
                <span class="text-danger-show"
                  *ngIf=" f['city']?.errors && f['city']?.errors['required']">{{'common.register_company_address_city_invalid'|cxTranslate}}</span>
              </div>
            </div>

          </div>

          <div class="d-flex flex-lg-row flex-column">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <ng-container>
                <label for="state"
                  class="control-label">{{'common.register_company_companyStateCode'|cxTranslate}}</label>
                <div class="select-box">
                  <select name="state" class="form-control" formControlName="state"
                    [ngClass]="{ 'is-valid': (f.state.dirty || submitted) && !f.state.errors, 'is-invalid': (f.state.dirty || submitted) && f.state.errors }">
                    <option value="null" disabled selected>{{'common.register_state_placeholder'|cxTranslate}}</option>
                    <option *ngFor="let item of stateList" [value]="item.isocode">{{item.name}}</option>
                  </select>
                  <div class="invalid-feedback">
                    <span class="text-danger-show"
                      *ngIf=" f['state']?.errors && f['state']?.errors['required']">{{'common.register_company_companyStateCode_invalid'|cxTranslate}}</span>
                  </div>
                </div>
              </ng-container>

            </div>
            <!--Zip-->
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="zip" class="control-label">{{'common.register_company_address_zip'|cxTranslate}}</label>
              <input type="text" maxlength="15" formControlName="zip" class="form-control" name="zip"
                [ngClass]="{ 'is-valid': (f.zip.dirty || submitted) && !f.zip.errors, 'is-invalid': (f.zip.dirty || submitted) && f.zip.errors }">
              <div class="invalid-feedback">
                <span class="text-danger-show"
                  *ngIf=" f['zip']?.errors && f['zip']?.errors['required']">{{'common.register_company_address_zip_invalid'|cxTranslate}}</span>
              </div>
            </div>
          </div>

          <!--Country-->
          <div class="d-flex flex-lg-row flex-column">

            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <ng-container *ngIf="(pageFieldData$|async) as pageFieldData">
                <label for="country" class="control-label">{{'common.register_company_countryCode'|cxTranslate}}</label>
                <div class="select-box">
                  <select name="country" class="form-control" formControlName="country"
                    (change)="onCountryChange($event)"
                    [ngClass]="{ 'is-valid': (f.country.dirty || submitted) && !f.country.errors, 'is-invalid': (f.country.dirty || submitted) && f.country.errors }">
                    <option value="null" disabled selected>{{'common.form_register_empty'|cxTranslate}}</option>
                    <option *ngFor="let item of pageFieldData['countriesWSList']" [value]="item.isocode">{{item.name}}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span class="text-danger-show"
                      *ngIf=" f['country']?.errors && f['country']?.errors['required']">{{'common.register_company_countryCode_invalid'|cxTranslate}}</span>
                  </div>
                </div>
              </ng-container>

            </div>

            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="phone" class="control-label">{{'common.register_company_phoneNumber'|cxTranslate}}</label>
              <input type="text" maxlength="15" formControlName="phone" class="form-control" name="phone">
            </div>

          </div>

          <!--Phone-->
          <div class="d-flex flex-lg-row flex-column">

            <!--Fax-->
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="fax" class="control-label">{{'common.register_company_faxNumber'|cxTranslate}}</label>
              <input type="text" maxlength="15" formControlName="fax" class="form-control" name="fax">
            </div>

            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="website" class="control-label">{{'common.register_company_website'|cxTranslate}}</label>
              <input type="text" formControlName="website" class="form-control" name="website">
            </div>
          </div>

          <div class="d-flex requestAcccess-section">
            <!--Requesting Access-->
            <ng-container *ngIf=pageFieldData>
              <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 requestAccess">
                <label for="email"
                  class="control-label regform-subtitle">{{'common.register_company_accessRequesting'|cxTranslate}}</label>
                <div class="form-check" *ngFor="let requestAccess of accessRequestsWSList">
                  <input class="form-check-input"
                    [checked]="editUserInfo?.editUserDetails?.accessRequestCodes?.indexOf(requestAccess.code)>-1"
                    (click)="selectRequestAccess($event, requestAccess)" [value]="requestAccess" type="checkbox">
                  <label class="form-check-label" for="distributor">
                    {{requestAccess.name}}
                  </label>
                </div>

              </div>
            </ng-container>
            <ng-container *ngIf=pageFieldData>
              <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 industryRole">
                <label for="email"
                  class="control-label regform-subtitle">{{'common.register_site_companyrole'|cxTranslate}}</label>
                <div class="form-check" [ngClass]="{ 'is-invalid': !selectedIndustryRole && submitted}"
                  *ngFor="let roleList of pageFieldData.industryRolesWSList; let i=index">
                  <input class="form-check-input" [id]="" (change)="selectIndustryRole($event, roleList)" type="radio"
                    [value]="roleList.code" [id]="'test'+i" name="industryRole" formControlName="industryRole">
                  <label class="form-check-label " for="distributor">
                    {{roleList.name}}
                  </label>
                </div>

              </div>
            </ng-container>

          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 user-register-space">
            <label class="my-account-subtitle m-b-15">
              {{'common.text_select_cutomer_id_user_account'|cxTranslate}}</label>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 select-customer-id" tabindex="0"
            (click)="showSearchResults($event)"> {{defaultSoldTo?.salesArea1}} |
            {{defaultSoldTo?.salesArea2|cxTranslate}} | {{defaultSoldTo?.salesArea3}}</div>
          <ng-container>
            <app-customer-id-drop-down *ngIf="showCustomerList" [pageSource]="'users'"
              (childValue)="selectedCust($event)"
              [customerId]="editUserInfo?.customerIdList"></app-customer-id-drop-down>
          </ng-container>

          <div class="col-xs-12 col-sm-12 col-md-12 linked-account-title user-register-space">
            <label class="my-account-subtitle m-b-15">
              {{'common.text_user_table_linked_customer'|cxTranslate}}</label>
          </div>
          <div class="linked-list">
            <ng-container *ngFor="let data of linkedCustomerList let i = index">
              <div class="customer_ID_Linked d-flex">
                <span>
                  <input class="form-check-input" [id]="" (click)="selectLinkedCust(data, i)" type="radio"
                    [value]="data.uid" [id]="'test'+i" name="linkedCustomerList" formControlName="linkedCustomerList">
                </span>
                <div class="customer_id_list">
                  {{data?.salesArea1}}&nbsp;|&nbsp;
                  <span *ngIf="data?.salesArea2">{{data?.salesArea2|cxTranslate}}&nbsp;|&nbsp;</span>
                  {{data?.salesArea3}}
                </div>
                <div class="remove">
                  <img (click)="removeLinkedAccount(data)" class="remove-linked-acc pointer" src="/icons/close-red.svg">
                </div>
              </div>
            </ng-container>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 btn-group edit-user-btn-section user-register-space">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 btn-group edit-user-btn-block">
              <button class="del-btn primary-btn"
                (click)="saveUser()">{{'common.text_user_table_save'|cxTranslate}}</button>
              <button (click)="decline()"
                class="lock-btn primary-btn">{{'common.text_consent_button_decline'|cxTranslate}}</button>
            </div>
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-6 btn-group d-flex justify-content-end edit-user-btn-block">
              <button class="user-rights"
                (click)="setUserRight(editUserInfo?.editUserDetails)">{{'common.mycompany_set_right'|cxTranslate}}
                <img src="/icons/link-right-blue.svg" alt="">
              </button>
              <button (click)="approve()" class="save-btn">{{'common.text_user_table_approve'|cxTranslate}}
                <img src="/icons/link-dark-grey.svg" alt="">
              </button>
            </div>
          </div>

        </form>
      </div>

    </div>

  </div>
</div>